export const CLEAR_JOTTER = 'waitrose/multisearch/CLEAR_JOTTER';
export const SET_JOTTER = 'waitrose/multisearch/SET_JOTTER';
export const USE_JOTTER = 'waitrose/multisearch/USE_JOTTER';

export const JOTTER_PENDING = 'waitrose/multisearch/JOTTER_PENDING';
export const JOTTER_FULFILLED = 'waitrose/multisearch/JOTTER_FULFILLED';
export const JOTTER_REJECTED = 'waitrose/multisearch/JOTTER_REJECTED';
export const START_LOADING = 'waitrose/multisearch/START_LOADING';
